import { Injectable, Injector } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { ToasterUtilService } from '../util/toaster-util.service';
import { SessaoUtil } from '../util/sessao-util';
import { GenericService } from './generic.service';
import { Router } from '@angular/router';
import { UsuarioModel } from '../util/model/usuario.model';
import { PermissaoModel } from '../util/model/permissao.model';
import { AlterarSenhaAuxModel } from '../util/model/alterar-senha-aux.model';
import { Select2OptionData } from 'ng2-select2';
import { EmpresaModel } from '../util/model/empresa.model';
import { UsuarioAuxModel } from '../util/model/usuario-aux.model';


@Injectable()
export class UsuarioService extends GenericService<UsuarioModel> {

  constructor (
    protected http: Http,
    protected sessaoUtil: SessaoUtil,
    protected toasterUtil: ToasterUtilService,
    protected router: Router,
    protected injector: Injector,
  ) {
      super(http, sessaoUtil, toasterUtil, router, injector, '/usuarios');
  }

  listaPermissoes(): Promise<Array<PermissaoModel>> {

    return this.http.post(this.getUrl() + '/listaPermissoes', null, { headers: this.getHeaders() })
        .toPromise()
        .then((response: Response)  => {
             this.handleMessage(response.headers);
             return response.json();
        }).catch(this.handleErrorRetornoValidacao.bind(this));
  }

  listaPermissoesUsuario(id: number): Promise<Array<PermissaoModel>> {

    return this.http.post(this.getUrl() + '/listaPermissoesUsuario', id, { headers: this.getHeaders() })
        .toPromise()
        .then((response: Response)  => {
             this.handleMessage(response.headers);
             return response.json();
        }).catch(this.handleErrorRetornoValidacao.bind(this));
  }

  listaEmpresasUsuario(id: number): Promise<Array<EmpresaModel>> {

    return this.http.post(this.getUrl() + '/listaEmpresasUsuario', id, { headers: this.getHeaders() })
        .toPromise()
        .then((response: Response)  => {
             this.handleMessage(response.headers);
             return response.json();
        }).catch(this.handleErrorRetornoValidacao.bind(this));
  }

  listaUsuariosEmpresas(entity: UsuarioAuxModel): Promise<Array<UsuarioModel>> {

    let tJSON = JSON.stringify(entity);

    return this.http.post(this.getUrl() + '/listaUsuariosEmpresas', tJSON, { headers: this.getHeaders() })
        .toPromise()
        .then((response: Response)  => {
             this.handleMessage(response.headers);
             return response.json();
        }).catch(this.handleErrorRetornoValidacao.bind(this));
  }

  alterarSenha(entity: AlterarSenhaAuxModel): Promise<boolean> {

    let tJSON = JSON.stringify(entity);

    return this.http.post(this.getUrl() + '/alterarSenha', tJSON, { headers: this.getHeaders() })
        .toPromise()
        .then((response: Response)  => {
             this.handleMessage(response.headers);
             return (response.status == 200);
        }).catch(this.handleErrorRetornoValidacao.bind(this));
  }

  selectOptionData(): Promise<Array<Select2OptionData>> {

    return this.http.post(this.getUrl() + '/selectOptionData', null, { headers: this.getHeaders() })
        .toPromise()
        .then((response: Response)  => {
             this.handleMessage(response.headers);
             return response.json();
        }).catch(this.handleErrorRetornoValidacao.bind(this));
  }

}



// WEBPACK FOOTER //
// ./src/app/service/usuario.service.ts